import React  from 'react'



const About = () => {
   
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-4'></div>
        <div className='col-8'>



        </div>

      </div>
      
    </div>
  )
}

export default About
